const normalizeBaseUrl = (url) => url.replace(/\/+$/, "");

// const BASE_URL_API = normalizeBaseUrl("http://localhost:800");
// const MEMBER_URL = normalizeBaseUrl("http://localhost:4003");
// const PAYMENT_URL = normalizeBaseUrl("http://localhost:4004");
// const EVENT_URL = normalizeBaseUrl("http://localhost:4314");
const BASE_URL_API = normalizeBaseUrl("https://api.pbforki.id");
const MEMBER_URL = normalizeBaseUrl("https://member.pbforki.id");
const PAYMENT_URL = normalizeBaseUrl("https://payment.pbforki.id");
const EVENT_URL = normalizeBaseUrl("https://event.pbforki.id");
//const BASE_URL_API = "https://apiikatei.teknologi40.com"; //
// var BASE_URL_API = 'mongodb://dani:dani@103.151.191.89:27017/portaldadi1';
// const BASE_URL_API = "http://localhost:501"; //

// const BASE_URL_API = StaticVar.URL_API; //
const StaticVar = {
  URL_API: BASE_URL_API,
  URL_REPO: `${BASE_URL_API}/media`,
  URL_MEMBER: MEMBER_URL,
  URL_PAYMENT: PAYMENT_URL,
  URL_EVENT: EVENT_URL,
};

export default StaticVar;
